import React from "react";
import PageHeader from "../components/PageHeader";
import { Leaf, Recycle, Globe, Scale, Heart } from "lucide-react";

const Sustainability = () => {
  return (
    <div className="bg-dreibach-black min-h-screen pb-24">
      <PageHeader 
        title="Responsibility" 
        subtitle="Growth with Conscience. As we scale to 500 containers a year, we acknowledge our responsibility to the planet."
        image="https://images.unsplash.com/photo-1542601906990-b4d3fb7d5c73?auto=format&fit=crop&q=80&w=2000"
      />

      <div className="container mx-auto px-6 py-24">
        
        <div className="grid md:grid-cols-3 gap-12">
          
          <div className="bg-dreibach-card border border-white/10 p-12 flex flex-col relative group overflow-hidden">
             <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                <Recycle className="w-24 h-24 text-green-500" />
             </div>
             <h3 className="text-2xl font-bold text-white uppercase tracking-wide mb-6">Packaging Reduction</h3>
             <p className="text-gray-400 leading-relaxed mb-8">
               We are actively minimising waste by optimising packaging sizes and transitioning to recyclable materials across all our brands.
             </p>
             <div className="mt-auto pt-8 border-t border-white/5">
                <span className="text-dreibach-teal text-sm font-bold uppercase tracking-wider">Environmental Impact</span>
             </div>
          </div>

          <div className="bg-dreibach-card border border-white/10 p-12 flex flex-col relative group overflow-hidden">
             <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                <Globe className="w-24 h-24 text-dreibach-teal" />
             </div>
             <h3 className="text-2xl font-bold text-white uppercase tracking-wide mb-6">Logistics Efficiency</h3>
             <p className="text-gray-400 leading-relaxed mb-8">
               Actively reducing both local and domestic footprint through smarter routing and multi-hub distribution strategies.
             </p>
             <div className="mt-auto pt-8 border-t border-white/5">
                <span className="text-dreibach-teal text-sm font-bold uppercase tracking-wider">Carbon Reduction</span>
             </div>
          </div>

          <div className="bg-dreibach-card border border-white/10 p-12 flex flex-col relative group overflow-hidden">
             <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                <Heart className="w-24 h-24 text-red-500" />
             </div>
             <h3 className="text-2xl font-bold text-white uppercase tracking-wide mb-6">Charity Support</h3>
             <p className="text-gray-400 leading-relaxed mb-8">
               Proud supporters of <span className="text-white font-bold">Great Ormond Street Hospital (GOSH)</span> through regular charity toy donations, bringing joy to children in care.
             </p>
             <div className="mt-auto pt-8 border-t border-white/5">
                <span className="text-dreibach-teal text-sm font-bold uppercase tracking-wider">Community Impact</span>
             </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Sustainability;
